import React, { useCallback, useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// styles
import { PerPageContainer } from '../../../../styles/Themes/StylesTheme1/MyAccountStyles'
import { OrdersContainer } from '../../../../styles/Themes/StylesTheme1/OrdersStyles'

// react toastify
import { toast } from 'react-toastify';

// redux actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// order details componets
import OrderDetailsView from './includes/OrderDetailsView';

// API
import { getOrderDetails } from 'utlis/Apis/Orders_API';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,

    ERROR_WHILE_GETTING_ORDER_DETAILS
} from "utlis/AppMessages/AppMessages";

function OrdersDetails(props) {
    // props
    const {
        parentProps,

        setGlobalLoading,

        commonToken
    } = props

    // states
    const [currentOrderId, setCurrentOrderId] = useState(null)
    const [orderDetails, setOrderDetails] = useState({})

    // checking current order Id
    useEffect(() => {
        if (parentProps?.match?.params?.orderId) {
            // setting global loading
            setGlobalLoading(true)

            // setting current route
            setCurrentOrderId(parentProps.match.params.orderId)

            // setting global loading
            setGlobalLoading(false)
        }
    }, [parentProps.match.params.orderId, setGlobalLoading])


    const getOrderDetailsFunction = useCallback(() => {
        if (currentOrderId) {
            // global loading
            setGlobalLoading(false)

            // getting data
            getOrderDetails(commonToken, currentOrderId).then(res => {
                const resData = res.data

                // global loading
                setGlobalLoading(false)

                // if success
                if (resData.success) {
                    setOrderDetails({
                        orders: resData.order,
                        orderItems: resData.order_items,
                        payments: resData.payments
                    }) // setting all orders data
                }

                // if error
                if (resData.error) {
                    console.log(`${ERROR_WHILE__NAME} getOrderDetails `, resData.message);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? ERROR_WHILE_GETTING_ORDER_DETAILS, {
                        autoClose: 2500
                    });
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getOrderDetails `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)
                    },
                });
            })
        }
    }, [currentOrderId, commonToken, setGlobalLoading])

    // getting data according to order id
    useEffect(() => {
        getOrderDetailsFunction()
    }, [getOrderDetailsFunction])

    return (
        <PerPageContainer>
            <div className="container">
                <div className="per-page-container-inner d-md-flex flex-wrap align-items-start">
                    <OrdersContainer className="media-body position-relative order-details-container">
                        <OrderDetailsView
                            orderDetails={orderDetails}
                        />
                    </OrdersContainer>
                </div>
            </div>
        </PerPageContainer >
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(OrdersDetails);